module.exports = __webpack_public_path__ + "img/Mockup_1.07613895.jpg";